@if (isVisible) {
  <form-control [question]="componentData" [flow]="flowComponent">
    <input #input lunaInput [id]="controlId" [name]="controlName" type="text" class="screen-only"
      [prefix]="prefix" [mask]="mask" [showMaskTyped]="showMask" [dropSpecialCharacters]="dropMaskSpecialCharacters" [thousandSeparator]="thousandSeparator" [specialCharacters]="specialCharacters" [allowNegativeNumbers]="allowNegativeNumbers"
      [formControl]="formGroup.controls[componentData.key]" (focus)="onFocus()" (blur)="onBlur()">
    </form-control>
    <div class="print-only">{{maskedInput}}</div>
  }

